import React, { Component } from 'react';
import {
  withRouter
} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import HeaderNavLink from '../HeaderNavLink';
import Contents from './Contents';
import '../../vendor/ionicons/css/ionicons.min.css';
import Gravatar from 'react-gravatar';

@inject('userStore')
@withRouter
@observer
class ClientApp extends Component {
    constructor(props){
        super(props);
        this.state = {
            sidebarVisible:false,
            folded:false
        }
    }

    componentDidMount(){
        console.log(this.props.userStore);
    }

    toggleNavigation = (e) => {
        e.preventDefault();
        console.log('calling side nav');
        this.setState({
            sidebarVisible:!this.state.sidebarVisible
        });
    }

    toggleFold = () => {
        console.log('calling fold');
        this.setState({
            folded:!this.state.folded
        });
    }


    render() {
        if (this.state.sidebarVisible){
            document.body.classList.add('topbar-menu-open');
        } else {
            document.body.classList.remove('topbar-menu-open');
        }
        if (this.state.folded){
            document.body.classList.add('sidebar-folded');
        } else {
            document.body.classList.remove('sidebar-folded');
        }
        return (
            <React.Fragment>
            <header className="topbar topbar-expand-lg">
                {this.state.sidebarVisible ? <div className="app-backdrop backdrop-topbar-menu" onClick={this.toggleNavigation}></div> : null}
              <div className="container">
                  <div className="topbar-left">
                    <span className="topbar-btn topbar-menu-toggler" onClick={this.toggleNavigation}><i>&#9776;</i></span>
                    <span className="topbar-brand"><img src={require('../../img/logo_se.png')} alt="SimplyEngaging.com"/></span>
                    <div className="topbar-divider d-none d-xl-block"></div>
                    <nav className="topbar-navigation">
                    </nav>
                  </div>

                  <div className="topbar-right">
                    <ul className="topbar-btns">
                      <li className="dropdown">
                        <span className="topbar-btn" data-toggle="dropdown"><Gravatar email={this.props.userStore.email} size={36} rating="pg" default="identicon" className="avatar" /></span>
                        <div className="dropdown-menu dropdown-menu-right">
                          <a className="dropdown-item" href="/account-settings"><i className="ti-settings"></i> Settings</a>
                          <div className="dropdown-divider"></div>
                          <a className="dropdown-item" href="/" onClick={()=>{this.props.userStore.logout();}}><i className="ti-power-off"></i> Logout</a>
                        </div>
                      </li>
                    </ul>
                    <span>{this.props.userStore.full_name}</span>
                  </div>
              </div>
            </header>
            <main className="main-container">
                <Contents></Contents>
                <footer className="site-footer">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="text-center text-md-left">Copyright © 2019 <a href="https://simplyengaging.com">Simply Engaging Technologies, LLC</a>. All rights reserved.</p>
                        <p className="text-center text-md-left text-hint fs-10">By using this site you agree to our <a href="/SE-terms-03132019.pdf">Terms of Use</a>.  Please see our <a href="/SE-pp-03132019.pdf">Privacy Policy</a></p>
                      </div>

                      <div className="col-md-6">
                        <ul className="nav nav-primary nav-dotted nav-dot-separated justify-content-center justify-content-md-end">
                          <li className="nav-item">
                                Hand-crafted in Minneapolis & Made with Love &hearts;
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </footer>
            </main>
            </React.Fragment>
        );
    }
}

export default ClientApp;



// WEBPACK FOOTER //
// ./src/components/client/ClientApp.js